import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SearchBar from './searchbar';
import Footer from './footer';
import { labels } from './labels';
import { handleRegexInput } from './util';

const Home = () => {
    const history = useHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const [reason, setReason] = useState("1");
    const [who, setWho] = useState("1"); // 1: 18 or older, 2: Under 18
    const [age, setAge] = useState("18");
    const [virtualist, setVirtualist] = useState(""); // "": not answered, "1": Yes, "0": No
    const [continueUrl, setContinueUrl] = useState("");
    const [showAlert, setShowAlert] = useState(false);

    // New state variables to control visibility
    const [showAgeTextField, setShowAgeTextField] = useState(false);
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.hash.replace("#", "?"));
        let a = urlParams.get('age');
        if (a) {
            var intAge = 18;
            try {
                intAge = parseInt(a);
            } catch {
            }
            setAge(a);
            if (intAge < 18) {
                setWho("2");
            }
        }
        // Initially, only show the age question        
        setShowAgeTextField(false);
    }, []);

    // Effect to manage visibility based on user selections
    useEffect(() => {
        // Logic based on "18 or older" question (who)
        if (who === "1") { // 18 or older (Yes)            
            setShowAgeTextField(false);            
        } else if (who === "2") { // Under 18 (No)   
            setAge("");
            setShowAgeTextField(true);           
        }
    }, [who]);


    useEffect(() => {
        var ageInput = document.getElementById("age") as HTMLInputElement;
        ageInput.focus();
    }, [showAgeTextField])

    function getAge() {
        return (document.getElementById("age") as HTMLInputElement).value;
    }

    function getWho() {
        return (document.getElementById("whoMe") as HTMLInputElement).checked ? "1" : "2"
    }

    function searchClick(e) {
        var ageRequired = (document.getElementById("whoElse") as HTMLInputElement).checked;

        var ageInput = document.getElementById("age") as HTMLInputElement;
        ageInput.classList.remove("is-invalid");

        var ageHeader = document.getElementById("ageHeader") as HTMLInputElement;
        ageHeader.classList.remove("is-invalid");

        if (ageRequired && (!ageInput.value || isNaN(parseInt(ageInput.value)))) {
            ageInput.classList.add("is-invalid");
            ageHeader.classList.add("is-invalid");
            return;
        }

        let c = `/search?age=${getAge()}`;
        
        setContinueUrl(c);
        if (ageRequired && getAge() === "") {
            setShowAlert(true);
        } else {
            history.push(c);
        }

    }

    function searchClickContinue(e) {
        setShowAlert(false);
        if (continueUrl) {
            const urlParams = new URLSearchParams(window.location.hash.replace("#", "?"));
            const selectedReason = urlParams.get("reason");
            let who = getWho();// (document.getElementById("whoMe") as HTMLInputElement).checked ? "1" : "2";
            let age = getAge();// (document.getElementById("age") as HTMLInputElement).value;
            //history.replace(window.location.hash = `#reason=${selectedReason}&who=${who}&age=${age}`);
            history.replace(window.location.hash = `#age=${age}`);
            history.push(continueUrl);
        }
    }

    return (<>
        <div className="d-flex container container-narrow bg-white justify-content-center px-4 px-sm-5">
            <div className="bg-white px-md-0">
                <div className="text-left pt-4 pb-2" style={{ marginLeft: "-8px" }}>
                    <a href="./"><img className="d-block" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px" }} /></a>
                </div>

                <div className="row justify-content-center">
                    <div className="col">
                        <div className="lead mb-2 homeTitle">{labels.home.title}</div>
                        {labels.home.newPatient}
                    </div>
                </div>

                <div className="row pt-4" id="reasonAnchor">
                    <div className="col-md-12">
                        <input type="hidden" id="visitReason" name="visitReason" value={1} />
                        <h2 className="mb-3">{labels.home.search.title}</h2>

                        {/* Age Question (18 or older?) */}
                        
                        <p><span className="d-inline-block pb-1 font-weight-bold">{labels.home.who.text}</span><br />
                            <input id="whoMe" name="who" type="radio" checked={who === "1"}
                                onChange={() => { setWho("1"); }} /> <label htmlFor="whoMe">{labels.home.who.options[0]}</label>
                            <br />
                            <input id="whoElse" name="who" type="radio" checked={who === "2"}
                                onChange={() => { setWho("2"); }} /> <label htmlFor="whoElse">{labels.home.who.options[1]}</label>
                        </p>
                        
                        {/* Age Text Field (visible if Under 18 is selected) */}
                        
                        <p className="pb-2" style={{ display: showAgeTextField ? "block" : "none" }}>
                            <label id="ageHeader" htmlFor="age" className="font-weight-bold">{labels.home.age.labels["1"]}</label><br />
                            <input placeholder={labels.home.age.placeholder}
                                id="age"
                                value={age}
                                className="form-control age"
                                maxLength={2}
                                autoComplete="off"
                                style={{ background: "none", width: "4.5em", display: "inline-block", minHeight: "40px", textAlign: "center" }}
                                onChange={(e) => handleRegexInput(e, setAge, /^1[0-7]$|^\d$|^$/)}
                            />
                            <div id="invalidLocation" className="invalid-feedback">{labels.home.age.error}</div>
                        </p>
                        
                        <div className="row">
                            <div className="col-md-4 mb-3 col-sm">
                                <button id="searchButton" className="btn btn-primary btn-md btn-block" type="submit" onClick={searchClick}>{labels.home.searchButton.text}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>);
}

export default Home;